

export const checarProduct = () => {
   
    const utmSources = ['rastreator', 'elinformador','driveapp','autochilango','waldos' ,'finsus', 'cybolt']

    return (utmSources.includes(window.localStorage.getItem('utm_source')!)) 
}